<template>
	<div class="menus-wrap">
		<head-info></head-info>
		<p class="tip">提示：只有正确上传照片的报考信息才能进入审核流程。请确保您的照片清晰免冠，以免审核不通过。</p>
		<el-upload
			:disabled="!check"
			:auto-upload="false"
			:class="{ hide: fileList.length }"
			style="margin:20px 0;"
			action="#"
			ref="uploadRef"
			:file-list="fileList"
			list-type="picture-card"
			:http-request="requestUpload"
			:on-remove="handleRemove"
			:on-change="handleChange"
			:before-upload="beforeAvatarUpload"
		>
			<i class="el-icon-plus"></i>
			<div slot="tip" class="el-upload__tip">
				<br />
				<span style="color: red;font-weight: 500;line-height: 1.5;">选择照片后，请点击上传照片按钮</span>
				<br />
				<a target="_blank" href="http://gs.offcn.com/zg/zhaopianshenhe.rar">点击下载照片处理工具</a>
			</div>
		</el-upload>
		<el-button v-if="check" style="margin-left: 10px;" type="primary" @click="submitUpload">上传照片</el-button>
	</div>
</template>

<script>
import HeadInfo from '@/components/HeadInfo';
import store from '@/store';
import { reqUploadFile, reqEditCandidatePhoto, reqGetUserPhoto, reqGetPhotoCandidateInfo } from '@/api';
import {mapGetters, mapState} from 'vuex';
export default {
	components: {
		HeadInfo
	},
	data() {
		return {
			photo: '',
			card_id: '',
			check: false,
			timer: null,
			fileList: []
		};
	},
	computed: {
		...mapState({
			examination_id: state => state.system.examInfo.examination_id,
			id: state => state.user.examinee.id,
		}),
		...mapGetters('user',['GET_USER_INFO']),
	},
	mounted() {
		this.getUserInfo();
		this.getPhoto();
	},
	methods: {
		getUserInfo() {
			reqGetPhotoCandidateInfo().then(res => {
				this.check = res.data.verify != 3 && res.data.verify_open;
				this.card_id = res.data.card_id;
			});
		},
		// 获取考生照片
		getPhoto() {
			let tempParams = [{url: this.GET_USER_INFO.photo + '?_=' + new Date().getTime()}]
       			this.photo = this.GET_USER_INFO.photo;
			this.fileList = this.photo?tempParams:[];
		},
		async requestUpload(options) {
			clearTimeout(this.timer);
			let temParams = {
				file: options.file,
				path: 'photo',
				name: this.id
			      };
			     
			await reqUploadFile(temParams, options.onProgress)
				.then(res => {
					options.onSuccess(res);
					this.photo = res.data;
				})
				.catch(() => {
					options.onError(res);
				});
			await reqEditCandidatePhoto({
				photo: this.photo,
				examination_id: this.examination_id
			      }).then(res => {
				this.$message.success('上传成功!!!');
				this.$store.dispatch('user/resetUserInfo');
				setTimeout(() => {
				   this.$router.push({path: '/info'})
				},1000)
			      })
		},
		submitUpload() {
			this.timer = setTimeout(() => {
				this.$message.warning('请选择需要上传的照片！');
			}, 500);
			this.$refs.uploadRef.submit();
		},
		beforeAvatarUpload(file) {
			clearTimeout(this.timer);
			let types = ['image/jpeg', 'image/jpg'];
			const isImage = types.includes(file.type);
			const isLtSize = file.size / 1024 <= 50;

			if (!isImage) {
				this.$message.error('上传图片只能是 jpg 格式!');
				return false;
			}
			if (!isLtSize) {
				this.$message.error('上传图片大小不能超过 50KB!');
				return false;
			}
			return isImage && isLtSize;
		},
		handleRemove(file, fileList) {
			this.photo = '';
			this.fileList = fileList;
		},
		handleChange(file, fileList) {
			this.fileList = fileList;
		}
	}
};
</script>

<style lang="scss" scoped>
.menus-wrap {
	display: flex;
	flex-direction: column;
	align-items: center;

	.tip {
		font-size: 14px;
		color: #ff070a;
		margin-top: 50px;
	}
}
</style>
<style>
.hide .el-upload--picture-card {
	display: none;
}
</style>
